import styled from 'styled-components';

import { media } from '../../utils/mediaQueries';

export const PageTitleWrapper = styled.div`
    display: grid;
    grid-template-columns: 1fr auto 1fr;
    align-items: end;
    padding: 15px 0;
    margin-bottom: 15px;
    border-bottom: 1px solid #d4d4d4;

    & > :first-child {
        justify-self: start;
    }

    & > :nth-child(2) {
        justify-self: center;
    }

    & > :last-child {
        justify-self: end;
    }

    ${media.mobile} {
        display: flex;
        flex-direction: row;
        align-items: flex-start;
        gap: 8px;
        padding: 8px 0;
        margin-bottom: 10px;
        max-width: 100%;
        overflow: hidden;

        & > :nth-child(2) {
            display: none;
        }

        & > :last-child {
            align-self: flex-start;
        }
    }
`;

export const Title = styled.div`
    display: flex;
    gap: 10px;
    align-items: baseline;
    flex-direction: row;
    justify-content: flex-start;

    ${media.mobile} {
        gap: 4px;
        min-width: 0;
        max-width: 100%;
        width: 100%;

        h1 {
            font-size: 1rem;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            max-width: calc(100vw - 100px);
            display: block;
        }
    }
`;

export const PageTitleActionBar = styled.div`
    display: grid;
    grid-template-columns: auto auto;
`;

export const EditWrapper = styled.div`
    width: 20px;
    height: 20px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    border-radius: 100%;
    background: ${({ theme }) => theme.colors.card.background};
`;

export const BtnBack = styled.span`
    font-size: 14px;
    padding: 4px 15px 8px 0;
    color: ${({ theme }) => theme.colors.text.primary};
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    transition: all 0.2s ease;
    border-radius: 6px;

    &:hover {
        transform: translateX(-4px);
        opacity: 0.7;
        outline: 1px solid ${({ theme }) => (theme.mode === 'dark' ? '#374151' : '#e5e7eb')};
        outline-offset: 2px;
    }

    &:active {
        transform: translateX(-2px);
    }

    ${media.mobile} {
        display: none;
    }
`;

export const ActionTextButton = styled.button`
    background: none;
    border: none;
    padding: 0;
    font-size: 14px;
    font-weight: 500;
    color: #1a4d4d;
    cursor: pointer;
    position: relative;
    transition: opacity 0.2s ease;

    &::after {
        content: '';
        position: absolute;
        left: 0;
        right: 0;
        bottom: -2px;
        height: 1px;
        background: #1a4d4d;
        transform: scaleX(0);
        transform-origin: right;
        transition: transform 0.2s ease;
    }

    &:hover {
        opacity: 0.8;

        &::after {
            transform: scaleX(1);
            transform-origin: left;
        }
    }

    &:active {
        opacity: 0.6;
    }
`;

export const MoreBoxIcon = styled.a`
    width: 30px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    background: ${({ theme }) => theme.colors.card.background};
    border-radius: 6px;
    transition: all 0.3s ease-in-out;
    opacity: 0.7;
    &:hover {
        opacity: 1;
    }
`;

export const ContextMenu = styled.div`
    padding: 4px;
    min-width: 180px;
`;

export const ContextMenuItem = styled.button<{ as?: string }>`
    width: 100%;
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 8px 12px;
    border: none;
    background: transparent;
    border-radius: 4px;
    font-size: 13px;
    font-weight: 400;
    color: ${({ theme }) => theme.colors.text.primary};
    cursor: pointer;
    transition: background 0.15s;
    text-align: left;
    white-space: nowrap;

    svg {
        flex-shrink: 0;
        color: ${({ theme }) => theme.colors.text.secondary};
    }

    &:hover {
        background: ${({ theme }) => (theme.mode === 'dark' ? '#242a33' : '#f3f4f6')};
    }
`;

export const ContextMenuDivider = styled.div`
    height: 1px;
    background: ${({ theme }) => (theme.mode === 'dark' ? '#374151' : '#e5e7eb')};
    margin: 4px 0;
`;
